import { AxiosResponse } from 'axios';
import { SubModelRequest } from '@/main/models/request';
import { Result } from '../../models/common/resultResponse';
import { api } from '../base/api';
import { ISubModelApi } from '../base/vehicle/subModelApi';
import { KeyValue } from '@/main/models/common/keyValue';

const baseRoute: string = 'SubModel';

export class SubModelApi extends ISubModelApi {
  getVehicleSubModel(
    request: SubModelRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`, { params: request });
  }

  getVehicleSubmodelByGuidCountry(
    request: SubModelRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/getVehicleSubmodelByGuidCountry`, { params: request });
  }
}
